import React, { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import AuthLayout from "./AuthLayout";
import { login } from "../../api/auth";
import { loginSuccess } from "../../store/authSlice";
import { ROLE_BUYER } from "../../config";

export default function Login() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);

	const formik = useFormik({
		initialValues: { email: "", password: "" },
		validationSchema: yup.object({
			email: yup.string().email("Enter a valid email").required("Email is required"),
			password: yup.string().required("Password is required"),
		}),
		onSubmit: async (values) => {
			setLoading(true);
			const res = await login(values.email.toLowerCase(), values.password);
			setLoading(false);
			if (res && !res.error && res.data?.token) {
				// Flutter app gates buyer login by role; mirror that check here.
				if (res.data.role && Number(res.data.role) !== ROLE_BUYER) {
					toast.error("This account is not a buyer account.");
					return;
				}
				dispatch(loginSuccess(res.data.token, res.data));
				navigate("/");
			} else {
				toast.error(res?.msg || "Login failed");
			}
		},
	});

	return (
		<AuthLayout heading="Welcome back!" subheading="Sign in to manage your fuel orders">
			<form onSubmit={formik.handleSubmit}>
				<div className="mb-3">
					<label className="form-label">Email</label>
					<input className="form-control" name="email" placeholder="Enter your email" value={formik.values.email} onChange={formik.handleChange} />
					{formik.touched.email && formik.errors.email ? <div className="text-danger small mt-1">{formik.errors.email}</div> : null}
				</div>
				<div className="mb-2">
					<label className="form-label">Password</label>
					<div className="input-group">
						<input type={showPassword ? "text" : "password"} className="form-control" name="password" placeholder="Enter your password" value={formik.values.password} onChange={formik.handleChange} />
						<button type="button" className="btn btn-outline-secondary" onClick={() => setShowPassword((s) => !s)}>
							{showPassword ? "Hide" : "Show"}
						</button>
					</div>
					{formik.touched.password && formik.errors.password ? <div className="text-danger small mt-1">{formik.errors.password}</div> : null}
				</div>
				<div className="text-end mb-3">
					<Link to="/forgot-password" className="small text-muted">Forgot password?</Link>
				</div>
				<button type="submit" className="btn-accent-solid w-100" disabled={loading}>
					{loading ? "Signing in..." : "Sign in"}
				</button>
				<div className="text-center mt-4 small">
					New to Ordr? <Link to="/signup" className="fw-semibold">Create a buyer account</Link>
				</div>
			</form>
		</AuthLayout>
	);
}
